import { useLocation as useReactRouterLocation } from "react-router-dom";
import type { Location as RouterLocation } from "history";
import { IAppRoute } from "@App/types";
import { useRoutes } from "./useRoutes";
import { IGenerateRouteQueryParams } from "../Contexts/RoutesContext";

export interface Location extends RouterLocation {
  fragments: IAppRoute[];
  queryParams: IGenerateRouteQueryParams;
}

export const useLocation = (): Location => {
  const location = useReactRouterLocation();
  const { routes } = useRoutes();

  const fragments = location.pathname.split("/").map((fragment) => {
    return Object.keys(routes).find(
      (key) => routes[key] === fragment
    ) as IAppRoute;
  });

  const queryParams = Object.fromEntries(new URLSearchParams(location.search));

  return { ...location, fragments, queryParams };
};
